import React from 'react';
import './Projects.css';
import { useLanguage } from '../context/LanguageContext';

// Local projects data (no API needed)
const projectsData = [
  {
    id: 1,
    title: "Creating websites",
    description: "Professional website development with modern design and responsive layouts.",
    image: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=800&h=600&fit=crop",
    link: "#"
  },
  {
    id: 2,
    title: "Customer Support Bot",
    description: "Intelligent chatbot handling 24/7 customer inquiries with natural language processing.",
    image: "https://images.unsplash.com/photo-1531746790731-6c087fecd65a?w=800&h=600&fit=crop",
    link: "#"
  },
  {
    id: 3,
    title: "Workflow Automation System",
    description: "Streamlined business processes with automated task management and reporting.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop",
    link: "#"
  },
  {
    id: 4,
    title: "SaaS Dashboard",
    description: "Beautiful analytics dashboard with real-time data visualization and insights.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop",
    link: "#"
  },
  {
    id: 5,
    title: "E-Commerce Platform",
    description: "Modern e-commerce solution with AI-powered recommendations and automated inventory management.",
    image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    link: "#"
  },
  {
    id: 6,
    title: "Mobile App Backend",
    description: "Scalable backend infrastructure for mobile applications with cloud integration.",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&h=600&fit=crop",
    link: "#"
  }
];

const Projects = () => {
  const { t } = useLanguage();

  // Map projects with translated titles and descriptions based on current language
  const projects = projectsData.map((project, index) => {
    const translatedProject = t.projects.items[index];
    return {
      ...project,
      title: translatedProject?.title || project.title || '',
      description: translatedProject?.description || project.description || ''
    };
  });

  return (
    <section id="projects" className="projects section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t.projects.title}</h2>
          <p className="section-subtitle">{t.projects.subtitle}</p>
        </div>
        <div className="projects-grid">
          {projects.map((project) => (
            <article key={project.id} className="project-card">
              <div className="project-image-wrapper">
                <img
                  src={project.image}
                  alt={project.title || ''}
                  className="project-image"
                  loading="lazy"
                  decoding="async"
                />
                <div className="project-image-shade" aria-hidden />
              </div>
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;

